import { NgModule, ModuleWithProviders } from '@angular/core';
import { AppComponent } from './app.component';
import { EmployeeAuthGuard } from './RoutingAuth/EmployeeAuthGuard';
import { LoggedInAuthGuard } from './RoutingAuth/LoggedInAuthGuard';
import { PaidAuthGuard } from './RoutingAuth/PaidAuthGuard';
import { HREmployeeAuthGuard } from './RoutingAuth/HREmployeeAuthGuard';
import { LMSEmployeeAuthGuard } from './RoutingAuth/LMSEmployeeAuthGuard';

@NgModule({
    providers: [
		
	]
})
export class AuthGuardModule {
	static forRoot(): ModuleWithProviders<AuthGuardModule> {
		return {
			ngModule: AuthGuardModule,
			providers: [
				EmployeeAuthGuard,
				LMSEmployeeAuthGuard,
				HREmployeeAuthGuard,
				LoggedInAuthGuard,
				PaidAuthGuard
			]
		};
	}
}
